import { render, staticRenderFns } from "./SvgMinus.vue?vue&type=template&id=02ed2e04&scoped=true&"
import script from "./SvgMinus.vue?vue&type=script&lang=js&"
export * from "./SvgMinus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ed2e04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02ed2e04')) {
      api.createRecord('02ed2e04', component.options)
    } else {
      api.reload('02ed2e04', component.options)
    }
    module.hot.accept("./SvgMinus.vue?vue&type=template&id=02ed2e04&scoped=true&", function () {
      api.rerender('02ed2e04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Offers/SvgMinus.vue"
export default component.exports